import { defaultApi } from '@/plugins/api/defaultApi'
import $store from '@/store'

const investingStatuses = ['received', 'investing', 'invested', 'executing']
const executedStatuses = ['executed']

export default {
  name: 'loan',
  namespaced: true,
  state: {
    repaymentsLoading: false,
    ongoingLoansLoading: false,
    ongoingLoans: [],
    loanAvailableTime: null,
    offer: null,
  },
  getters: {
    getRepaymentsLoading(state) {
      return state.repaymentsLoading
    },
    getOngoingLoansLoading(state) {
      return state.ongoingLoansLoading
    },
    // 당겨받기 상품 생성 요청 가능여부
    isPullRevenueOfferRequest(state, getters) {
      const result = getters.ongoingPullRevenues.find((r) => true)
      return result ? false : true
    },
    // 비상금 상품 생성 요청 가능여부
    isFastLoanOfferRequest(state, getters) {
      const result = getters.ongoingFastLoan.find((r) => true)
      return result ? false : true
    },
    // 당겨받기 상품 생성 요청 가능여부
    isWooricrowdsOfferRequest(state, getters) {
      const result = getters.ongoingWooricrowds.find((r) => true)
      return result ? false : true
    },
    ongoingPullRevenues(state) {
      return state.ongoingLoans.filter((d) => d.type === 'normal' && d.offer.periodInDays === 60)
    },
    ongoingFastLoan(state) {
      return state.ongoingLoans.filter(
        (d) =>
          d.type === 'normal' &&
          d.offer.loanType === 'normal' &&
          (d.offer.periodInDays === 45 ||
            d.offer.periodInDays === 60 ||
            d.offer.periodInDays === 120),
      )
    },
    ongoingWooricrowds(state) {
      return state.ongoingLoans.filter(
        (d) => d.type === 'normal' && d.offer.loanType === 'woori_crowd',
      )
    },
    ongoingBnplJangsa3(state) {
      return state.ongoingLoans.filter(
        (d) => d.type === 'normal' && d.offer.loanType === 'BNPL_JANGSA3',
      )
    },
    ongoingBnplInsur(state) {
      return state.ongoingLoans.filter(
        (d) => d.type === 'normal' && d.offer.loanType === 'BNPL_INSUR',
      )
    },
    ongoingBnplCollection(state) {
      return state.ongoingLoans.filter(
        (d) => d.type === 'normal' && d.offer.loanType === 'BNPL_COLLECTION',
      )
    },
    investingPullRevenue(state, getters) {
      return getters.ongoingPullRevenues.find((r) => investingStatuses.includes(r.status))
    },
    investingFastLoan(state, getters) {
      return getters.ongoingFastLoan.find((r) => investingStatuses.includes(r.status))
    },
    investingWooriCrowd(state, getters) {
      return getters.ongoingWooricrowds.find((r) => investingStatuses.includes(r.status))
    },
    investingBnplJangsa3(state, getters) {
      return getters.ongoingBnplJangsa3.find((r) =>
        investingStatuses.includes(r.status),
      )
    },
    investingBnplInsur(state, getters) {
      return getters.ongoingBnplInsur.find((r) =>
        investingStatuses.includes(r.status),
      )
    },
    executedPullRevenue(state, getters) {
      return getters.ongoingPullRevenues.find((r) => executedStatuses.includes(r.status))
    },
    executedFastLoan(state, getters) {
      return getters.ongoingFastLoan.find((r) => executedStatuses.includes(r.status))
    },
    executedWooriCrowd(state, getters) {
      return getters.ongoingWooricrowds.find((r) => executedStatuses.includes(r.status))
    },
    isLoanAvailableTime(state) {
      return state?.loanAvailableTime?.canLoan || $store.state?.auth?.me?.isLoanAvailableTemporarily
    },
    getOffer(state) {
      return state.offer
    },
    isEarlyPaymentEnabled(state, getters, rootState) {
      const contractCurrent = rootState.contract.current
      return (
        contractCurrent?.status === 'started' && contractCurrent?.isEarlyPaymentEnabled === true
      )
    },
  },
  mutations: {
    setOngoingLoansLoading(state, flag) {
      state.ongoingLoansLoading = flag
    },
    setOngoingLoans(state, ongoingLoans) {
      state.ongoingLoans = ongoingLoans
    },
    setRepaymentsLoading(state, flag) {
      state.repaymentsLoading = flag
    },
    setLoanAvailableTime(state, loanAvailableTime) {
      state.loanAvailableTime = loanAvailableTime
    },
    setOffer(state, offer) {
      state.offer = offer
    },
  },
  actions: {
    async addLoansOffersCurrent({}, query) {
      const { data } = await defaultApi.getLoansOffersCurrent(query)
      return data
    },
    async getLoansOffersCurrent({}) {
      const { data } = await defaultApi.getLoansOffersCurrent()
      return data
    },
    async getLoansOfferEarlyPayment() {
      const { data } = await defaultApi.postLoansOfferEarlyPayment()
      return data
    },
    async getLoansExecuteFunding() {
      const { data } = await defaultApi.getLoansExecuteFunding()
      return data
    },
    async getRepaymentsSimple({ commit, getters }, date) {
      const isLoading = getters.getRepaymentsLoading
      if (isLoading) {
        return
      }
      commit('setRepaymentsLoading', true)
      try {
        const q = { created__date: date }
        const { data } = await defaultApi.getRepaymentsSimple(q)
        return data
      } finally {
        commit('setRepaymentsLoading', false)
      }
    },
    async getLoansByOngoing({ commit }, ongoing = true) {
      try {
        commit('setOngoingLoansLoading', true)
        const { data } = await defaultApi.getLoans({
          ongoing,
        })
        // request 추가
        // for (const f of data) {
        //   const { data: request } = await defaultApi.getLoansRequestByLoan(f.uuid)
        //   f.request = request
        // }
        commit('setOngoingLoans', data)
        return data
      } finally {
        commit('setOngoingLoansLoading', false)
      }
    },
    async getLoans({}, param) {
      const { data } = await defaultApi.getLoans(param)
      return data
    },

    async getLoansDetail({}, uuid) {
      const { data } = await defaultApi.getLoansDetail(uuid)
      return data
    },
    async getLoansRepayments({}, uuid) {
      const { data } = await defaultApi.getLoansRepayments(uuid)
      return data
    },

    async getInvestingAmount({}, uuid) {
      const { data } = await defaultApi.getInvestingAmount(uuid)
      return data
    },

    /**
     * 대출 step 1
     * 대출 생성
     */
    async createLoan({ dispatch }, offer) {
      const { data } = await defaultApi.postLoansCreate(offer.uuid)
      console.log('!!!!!!!!!!! postLoansCreate 응답', data)

      await defaultApi.getLoansRegisterFunding(data.uuid)
      // 대출 생성후 현재상태 갱신
      await dispatch('getLoansByOngoing')
      return data
    },

    /**
     * 대출 step 2
     * 투자 모집 종료
     */
    async closeLoan({}, uuid) {
      const { data } = await defaultApi.getCloseFunding(uuid)
      return data
    },

    /**
     * 대출 step 3
     * 대출 실행
     */
    async executeLoan({}, uuid) {
      const { data } = await defaultApi.geExecuteFunding(uuid)
      return data
    },
    /**
     * 대출 요청 가능시간
     * @returns
     */
    async getLoanAvailableTime({ commit }) {
      const { data } = await defaultApi.getLoanAvailableTime()
      commit('setLoanAvailableTime', data)
      return data
    },

    updateOffer({ commit }, offerData) {
      commit('setOffer', offerData) // Action to commit the offer data
    },
  },
}
